import { List, Typography, Card } from 'antd';
import step1 from './Images_Instagram/step - 1.jpeg';
import step2 from './Images_Instagram/step - 2.jpeg';
import step3 from './Images_Instagram/step - 3.jpeg';
import step4 from './Images_Instagram/step - 4.jpeg';
import step5 from './Images_Instagram/step - 5.jpeg';
import step6 from './Images_Instagram/step - 6.jpeg';
import step7 from './Images_Instagram/step - 7.jpeg';
import step8 from './Images_Instagram/step - 8.jpeg';
import step9 from './Images_Instagram/step - 9.jpeg';
import step10 from './Images_Instagram/step - 10.jpeg';
import step11 from './Images_Instagram/step - 11.jpeg';
import step12 from './Images_Instagram/step - 12.jpeg';
import step13 from './Images_Instagram/step - 13.jpeg';
import step14 from './Images_Instagram/step - 14.jpeg';
import step15 from './Images_Instagram/step - 15.jpeg';

import './Request.css';

const { Text, Link, Title } = Typography;




// 
// 
// .
// .
// .
// .
// .
// .
// .
// .


const data = [
    {
        title: 'Step 1',
        image: step1,
        description: 'Open Instagram app and click on "Profile" button at the bottom right of your screen'
    },
    {
        title: 'Step 2',
        image: step2,
        description: 'Press the button with the three horizontal bars at the top right of your screen'
    },
    {
        title: 'Step 3',
        image: step3,
        description: 'Press the "Accounts centre" button in the popped up menu'
    },
    {
        title: 'Step 4',
        image: step4,
        description: 'Press the "information and permissions" button in the Accounts centre menu'
    },
    {
        title: 'Step 5',
        image: step5,
        description: 'Press the "Download your information" button'
    },
    {
        title: 'Step 6',
        image: step6,
        description: 'Press the "Download or transfer information" button'
    },
    {
        title: 'Step 7',
        image: step7,
        description: 'Skip this step if you have only one profile linked. Choose the profile if you have more than one profile linked and click "Next"'
    },
    {
        title: 'Step 8',
        image: step8,
        description: 'Press the "All available information" button'
    },
    {
        title: 'Step 9',
        image: step9,
        description: 'Press the "Download to device" button'
    },
    {
        title: 'Step 10',
        image: step10,
        description: 'Click on "Date range" button on create files page'
    },
    {
        title: 'Step 11',
        image: step11,
        description: 'Click on "All time" and press "Save" button'
    },
    {
        title: 'Step 12',
        image: step12,
        description: 'Click on "Fomat" button on create files page'
    },
    {
        title: 'Step 13',
        image: step13,
        description: 'Click on "JSON" and click on "x" to visit create files page'
    },
    {
        title: 'Step 14',
        image: step14,
        description: 'Click on "Create Files" button to request the data'
    },
    {
        title: 'Step 15',
        image: step15,
        description: <div><Text>Your data will become ready after a few days and you will be able to download it in "Download your information" page. Once you have your JSON file, proceed to the </Text>
            <Link href="/donate" target="_blank">
                Data Donation page
            </Link>
            <Text>on this site to submit your data</Text>
            </div>
    },
];

export const InstagramRequest = () => {
    return (
        <div>
            <Title>How to Request Your Instagram Data</Title>
            <List grid={{ gutter: 16, column: Math.floor((window.innerWidth) / 260) }}
                dataSource={data}
                renderItem={item => (
                    <List.Item>
                        <Card title={item.title} cover={<img className="RequestCardImageMobile" src={item.image} />} >{item.description}</Card>
                    </List.Item>
                )} />
        </div>
    );
}

export default InstagramRequest;